import {
    Breadcrumb,
    Header,
    Paragraph,
    useStyles,
    pxToRem,
    Flex,
    DESKTOP_TOP_NAV_HEIGHT_WITH_SECOND_NAV,
} from '@archipro-design/aria';
import { Link } from '@remix-run/react';
import * as S from './PageHeader.style';
import { useTracker } from '@archipro-website/tracker';
import type { PageHeaderProps } from './PageHeader';
import { COMPANY_ENQUIRY_FORM_ANCHOR } from '~/modules/company-profile/CompanyProfile';
import { useScroll, useSize } from 'ahooks';
import type { ElementType } from 'react';
import { useRef } from 'react';
import { Button as RoccoButton } from '@archipro/rocco/components/button';
export const PageHeaderDesktop = ({
    data: { Breadcrumbs, Title, Professional, ProjectHeroTitle },
}: PageHeaderProps) => {
    const tracker = useTracker();
    const containerRef = useRef<HTMLDivElement>(null);
    const innerRef = useRef<HTMLDivElement>(null);
    const innerSize = useSize(innerRef);

    const position = useScroll();
    const { css } = useStyles({
        innerHeight: innerSize?.height,
        scrollY: position?.top,
    });

    const displayedTitle = ProjectHeroTitle || Title;

    return (
        <div ref={containerRef} className={css(S.ProjectHeaderContainer)}>
            <div className={css(S.PageHeader)}>
                <div className={css(S.PageHeaderInner)}>
                    <div className={css(S.LeftPane)}>
                        <Breadcrumb
                            logo={null}
                            home={{
                                link: true,
                                as: Link,
                                label: 'Home',
                                to: '/',
                            }}
                            className={css(S.BreadCrumb)}
                            items={Breadcrumbs.map((breadcrumb) => ({
                                ...breadcrumb,
                                as: breadcrumb.as as ElementType,
                            }))}
                            data-testid="breadcrumb-menu"
                            variables={{
                                breadcrumbLogoSpacing: pxToRem(3),
                            }}
                        />
                    </div>
                    <div className={css(S.RightPane)}>
                        <div className={css(S.RightPaneInner)}>
                            <div className={css(S.ProjectTitleContainer)}>
                                <Header
                                    as="h1"
                                    className={css(S.ProjectTitle)}
                                    uc={true}
                                >
                                    {displayedTitle}
                                </Header>
                                <Link
                                    to={Professional.Link}
                                    onClick={() => {
                                        tracker.log('ProjectProfileClick', {
                                            url: new URL(window.location.href),
                                            targetTracker: 'archiproTracker',
                                        });
                                    }}
                                    prefetch="intent"
                                >
                                    <Paragraph
                                        className={css(S.ProfessionalTitle)}
                                    >
                                        {`By ${Professional.Title}`}
                                    </Paragraph>
                                </Link>
                            </div>

                            <Flex gap="space-10">
                                <RoccoButton
                                    size="larger"
                                    color="secondary"
                                    layoutMode="noShrink"
                                    asChild
                                    onClick={() => {
                                        tracker.log(
                                            'ProjectProfileButtonClick',
                                            {
                                                url: new URL(
                                                    window.location.href,
                                                ),
                                                targetTracker: [
                                                    'archiproTracker',
                                                    'ga4Tracker',
                                                ],
                                            },
                                        );
                                    }}
                                >
                                    <Link to={Professional.Link}>
                                        View Profile
                                    </Link>
                                </RoccoButton>

                                <RoccoButton
                                    color="primary"
                                    size="larger"
                                    layoutMode="noShrink"
                                    onClick={() => {
                                        window.scrollTo({
                                            top:
                                                (document.getElementById(
                                                    COMPANY_ENQUIRY_FORM_ANCHOR,
                                                )?.offsetTop ?? 0) -
                                                DESKTOP_TOP_NAV_HEIGHT_WITH_SECOND_NAV,
                                            behavior: 'smooth',
                                        });
                                    }}
                                >
                                    Enquire
                                </RoccoButton>
                            </Flex>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
